/**
 * Preview mode for a not-yet-public trust page.
 *
 * The dashboard links to `${TRUST_URL}/${slug}?preview=1`. The session token
 * is never in the URL and never read from document.cookie. The preview fetch
 * sends the HttpOnly cookie with credentials. The API derives the tenant
 * from that cookie, so a visitor can only preview their own page. Without
 * the query flag, the page stays on the public path.
 */

export const PREVIEW_QUERY_PARAM = 'preview'

export function isPreviewRequested(search: string): boolean {
  return new URLSearchParams(search).get(PREVIEW_QUERY_PARAM) === '1'
}
